import React from "react";
import { Send, Mail, Clock, ShieldCheck, PackageSearch } from "lucide-react";
import { Link } from "react-router-dom";
import { siteConfig as fallback } from "../mock";
import { useSite } from "../context/SiteContext";
import { img } from "../lib/api";
import BrandLogo from "./BrandLogo";

const Footer = () => {
  const { settings } = useSite();
  const s = settings || fallback;
  const payments = s.payments || [];
  return (
    <footer className="bg-navy-800 border-t border-gold/15 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <BrandLogo settings={s} size="h-12 w-12" testId="footer-logo" />
              <span className="font-display font-bold text-xl liquid-gold-text" data-testid="footer-brand-name">{s.brandName}</span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">{s.footerAbout}</p>
            <div className="mt-5 flex flex-wrap gap-5">
              <Link to="/track" data-testid="footer-track-link" className="inline-flex items-center gap-2 text-sm text-gold hover:underline"><PackageSearch size={16} /> Track your order</Link>
              <Link to="/contact" data-testid="footer-contact-link" className="inline-flex items-center gap-2 text-sm text-gold hover:underline"><Mail size={16} /> Contact us</Link>
            </div>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4 font-display">Contact</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              {s.contact?.telegramLink && <li className="flex items-center gap-3"><Send size={16} className="text-gold" /><a href={s.contact?.telegramLink} target="_blank" rel="noreferrer" className="hover:text-gold transition-colors">{s.contact?.telegramHandle}</a></li>}
              <li className="flex items-center gap-3"><Mail size={16} className="text-gold" /><a href={`mailto:${s.contact?.supportEmail}`} className="hover:text-gold transition-colors">{s.contact?.supportEmail}</a></li>
              <li className="flex items-center gap-3"><Clock size={16} className="text-gold" />{s.contact?.hours}</li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-4 font-display">Payments</h4>
            <div className="flex flex-wrap gap-2">
              {payments.map((p) => (
                <span key={p.id} className="inline-flex items-center gap-1.5 text-xs text-slate-300 bg-navy-700 gold-border rounded-full px-3 py-1.5">
                  {p.logo && <img src={img(p.logo)} alt="" className="h-3.5 w-3.5" />}{p.name}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="mt-10 bg-navy-700/50 rounded-xl p-4 border border-white/5">
          <p className="text-xs text-slate-500 leading-relaxed"><span className="text-slate-300 font-semibold">Disclaimer:</span> {s.disclaimer}</p>
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">&copy; {new Date().getFullYear()} {s.brandName}. All rights reserved. Props for creative use only.</p>
          <div className="flex items-center gap-2 text-xs text-slate-400"><ShieldCheck size={15} className="text-gold" /> 100% discreet &amp; secure checkout</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
